import * as React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import { TagsProps } from './TagProps';

export default function Tags({
  initialOptions,
  initialSelected,
  setSelected,
}: TagsProps): React.JSX.Element {
  return (
    <Box sx={{ width: '100%' }}>
      <Autocomplete
        multiple
        freeSolo
        size="small"
        fullWidth
        options={initialOptions}
        value={initialSelected}
        onChange={(event, newValue) => {
          setSelected(newValue as string[]);
        }}
        renderTags={(value: readonly string[], getTagProps) =>
          value.map((option: string, index: number) => {
            const { key, ...tagProps } = getTagProps({ index });
            return (
              <Chip
                size="small"
                variant="outlined"
                color="primary"
                label={option}
                key={key}
                {...tagProps}
                sx={{
                  bgcolor: 'action.hover',
                  borderRadius: 1,
                  border: '1px solid',
                  borderColor: 'divider',
                  fontWeight: 600,
                  backdropFilter: 'blur(10px)',
                }}
              />
            );
          })
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            size="small"
            label="Tags"
            fullWidth
            placeholder={
              initialSelected.length === 0 ? 'Type or select tags...' : ''
            }
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: 2,
                bgcolor: 'background.paper',
                transition: 'all 0.2s',
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'primary.main',
                },
              },
            }}
          />
        )}
      />
    </Box>
  );
}
